export default "__VITE_ASSET__CJWEOvYk__"